import scssColors from '/styles/_colors.module.scss'

export const colors = {
  global: {
    primary: {
      '100': scssColors.globalPrimary100,
      '200': scssColors.globalPrimary200,
      '300': scssColors.globalPrimary300,
      '400': scssColors.globalPrimary400,
      '500': scssColors.globalPrimary500,
      '600': scssColors.globalPrimary600,
      '700': scssColors.globalPrimary700,
      '800': scssColors.globalPrimary800,
      '900': scssColors.globalPrimary900
    },
    secondary: {
      '100': scssColors.globalSecondary100,
      '200': scssColors.globalSecondary200,
      '300': scssColors.globalSecondary300,
      '400': scssColors.globalSecondary400,
      '500': scssColors.globalSecondary500,
      '600': scssColors.globalSecondary600,
      '700': scssColors.globalSecondary700,
      '800': scssColors.globalSecondary800,
      '900': scssColors.globalSecondary900
    }
  },
  text: {
    body: scssColors.textBody,
    bodyLight: scssColors.textBodyLight,
    link: scssColors.textLink,
    muted: scssColors.textMuted,
    promotional: scssColors.textPromotional
  },
  feedback: {
    success: {
      '100': scssColors.feedbackSuccess100,
      '200': scssColors.feedbackSuccess200,
      '300': scssColors.feedbackSuccess300,
      '400': scssColors.feedbackSuccess400,
      '500': scssColors.feedbackSuccess500,
      '600': scssColors.feedbackSuccess600,
      '700': scssColors.feedbackSuccess700,
      '800': scssColors.feedbackSuccess800,
      '900': scssColors.feedbackSuccess900
    },
    info: {
      '100': scssColors.feedbackInfo100,
      '200': scssColors.feedbackInfo200,
      '300': scssColors.feedbackInfo300,
      '400': scssColors.feedbackInfo400,
      '500': scssColors.feedbackInfo500,
      '600': scssColors.feedbackInfo600,
      '700': scssColors.feedbackInfo700,
      '800': scssColors.feedbackInfo800,
      '900': scssColors.feedbackInfo900
    },
    warning: {
      '100': scssColors.feedbackWarning100,
      '200': scssColors.feedbackWarning200,
      '300': scssColors.feedbackWarning300,
      '400': scssColors.feedbackWarning400,
      '500': scssColors.feedbackWarning500,
      '600': scssColors.feedbackWarning600,
      '700': scssColors.feedbackWarning700,
      '800': scssColors.feedbackWarning800,
      '900': scssColors.feedbackWarning900
    },
    danger: {
      '100': scssColors.feedbackDanger100,
      '200': scssColors.feedbackDanger200,
      '300': scssColors.feedbackDanger300,
      '400': scssColors.feedbackDanger400,
      '500': scssColors.feedbackDanger500,
      '600': scssColors.feedbackDanger600,
      '700': scssColors.feedbackDanger700,
      '800': scssColors.feedbackDanger800,
      '900': scssColors.feedbackDanger900
    }
  },
  neutral: {
    high: {
      light: scssColors.neutralHighLight,
      pure: scssColors.neutralHighPure
    },
    low: {
      dark: scssColors.neutralLowDark,
      pure: scssColors.neutralLowPure
    }
  },
  disabled: {
    global: {
      primary: {
        '500': scssColors.disabledGlobalPrimary500
      },
      secondary: {
        '500': scssColors.disabledGlobalSecondary500
      }
    },
    text: {
      body: scssColors.disabledTextBody,
      link: scssColors.disabledTextLink,
      muted: scssColors.disabledTextMuted
    },
    feedback: {
      success: {
        '500': scssColors.disabledFeedbackSuccess500
      },
      info: {
        '500': scssColors.disabledFeedbackInfo500
      },
      warning: {
        '500': scssColors.disabledFeedbackWarning500
      },
      danger: {
        '500': scssColors.disabledFeedbackDanger500
      }
    }
  },
  stroke: {
    primary: {
      dark: scssColors.strokePrimaryDark,
      light: scssColors.strokePrimaryLight
    },
    secondary: {
      dark: scssColors.strokeSecondaryDark,
      light: scssColors.strokeSecondaryLight
    }
  },
  overlay: {
    dark: {
      '30': scssColors.overlayDark30
    },
    light: {
      '20': scssColors.overlayLight20,
      '50': scssColors.overlayLight50
    }
  }
}
